import React from 'react';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { CpdBundleHaveCourseTagBox } from './style';

type Props = {
  isCPD?: boolean;
};
const CpdBundleHaveCourseTag = ({ isCPD = false }: Props) => {
  const { t } = useTranslation('common');

  return (
    <CpdBundleHaveCourseTagBox>
      <CheckCircleOutlineIcon className="check-circle-outline-icon" />
      <Typography className="text">
        {isCPD ? (
          <span>{t('product_detail.bundle.cpd_enrolled')}</span>
        ) : (
          <span>{t('product_detail.bundle.regular_enrolled')}</span>
        )}
      </Typography>
    </CpdBundleHaveCourseTagBox>
  );
};

export default CpdBundleHaveCourseTag;
